import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { NgbNav, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';

import { Facility } from '@digital-platform/rs-cms/domain';
import { RichTextLinkComponent } from '@digital-platform/rs-cms/feature-ptypes';
import { CmsFacilitiesService } from '@digital-platform/rs-cms/services';
import { FacilityLocation } from '@digital-platform/rs-maps/domain';
import { BingMapComponent } from '@digital-platform/rs-maps/feature-bing-map';
import { FacilityFilterServiceComponent } from '../facility-filter-service/facility-filter-service.component';
import { FacilityItemComponent } from '../facility-item/facility-item.component';
import { FacilityResultsComponent } from '../facility-results/facility-results.component';

@Component({
  selector: 'digital-platform-facility-tabs',
  templateUrl: './facility-tabs.component.html',
  styleUrls: ['./facility-tabs.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    NgbNavModule,
    FacilityItemComponent,
    RichTextLinkComponent,
    FacilityResultsComponent,
    BingMapComponent,
    FacilityFilterServiceComponent,
  ],
})
export class FacilityTabsComponent implements AfterViewInit, OnChanges {
  @ViewChild('nav', { static: false }) nav!: NgbNav;
  @Input() facilities: Facility[] | null = null;
  @Input() filteredFacilities: Facility[] | null = null;
  @Input() availableServices: { [service: string]: boolean } = {};
  @Input() stateKey: string | undefined;
  @Input() selectedServices: string[] = [];
  @Input() serviceBadgesHeight = 0;
  @Output() updateSelectedServices = new EventEmitter<string[]>();
  @Output() updateMapFilter = new EventEmitter<
    Facility[] | FacilityLocation[]
  >();
  activeFacility!: Facility | FacilityLocation;

  zoom!: number;
  latitude!: number;
  longitude!: number;

  constructor(private cmsFacilitiesService: CmsFacilitiesService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['stateKey'] && this.nav) {
      this.nav.select(2);
    }
  }

  ngAfterViewInit() {
    this.cmsFacilitiesService.selectedFacility.subscribe(
      (facility: Facility | FacilityLocation) => {
        this.activeFacility = facility;
        this.nav.select(1); // 1st Tab
      }
    );
  }

  onTabChange(tab: number): void {
    if (tab === 1) {
      // 1st Tab
      this.cmsFacilitiesService.updateSelectedFacility(this.activeFacility);
    }
  }

  public handleUpdateServices(selectedServices: string[]): void {
    this.updateSelectedServices.emit(selectedServices);
  }

  public handleUpdateMap(facilities: Facility[] | FacilityLocation[]): void {
    this.updateMapFilter.emit(facilities);
  }

  public handleUpdateCoordinates(coordinates: {
    latitude: number;
    longitude: number;
  }): void {
    this.latitude = coordinates.latitude;
    this.longitude = coordinates.longitude;
  }

  public handleUpdateZoom(zoom: number): void {
    this.zoom = zoom;
  }
}
